var exports = {
  "message-bubble": "x61f99309--c4158f--message-bubble",
  "message-bubble_type_outcoming": "x61f99309--c4158f--message-bubble_type_outcoming",
  "message-bubble_type_incoming": "x61f99309--c4158f--message-bubble_type_incoming",
  "message-bubble_type_unread": "x61f99309--c4158f--message-bubble_type_unread",
  "message-bubble__content": "x61f99309--c4158f--message-bubble__content",
  "message-bubble_theme_purple": "x61f99309--c4158f--message-bubble_theme_purple",
  "message-bubble__highlight-overlay": "x61f99309--c4158f--message-bubble__highlight-overlay",
  "highlight-overlay": "x61f99309--c4158f--highlight-overlay",
  "message-bubble__tail": "x61f99309--c4158f--message-bubble__tail",
};

module.exports = exports;
